import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "arrow"]

  connect() {
    this.checkScrollPosition()
  }

  checkScrollPosition() {
    const container = this.containerTarget
    const arrow = this.arrowTarget

    // 检查是否滚动到底部
    // scrollHeight - scrollTop - clientHeight 如果小于等于1（考虑浮点数误差），说明到底了
    const isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight <= 1

    if (isAtBottom) {
      // 旋转180度
      arrow.style.transform = 'rotate(180deg)'
    } else {
      // 恢复原状
      arrow.style.transform = 'rotate(0deg)'
    }
  }

  onScroll() {
    this.checkScrollPosition()
  }

  close() {
    // 直接添加 hidden 类来关闭下拉菜单
    this.containerTarget.classList.add('hidden')
  }
}

